/// <reference path="../CollectionPanel.ts"/>
class AllCollections extends CollectionPanel {

	constructor(title: string, id?: number | string, sort?: string) {
		super(title);

		this.type = CollectionType.All;
		this.sort = sort;

		this.view();
		this.setUpEvents();
		this.getData(id);
	}
}